import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthenticationService } from 'src/app/core/services/Authentication/authentication.service';
import { HitmakerService } from 'src/app/core/services/hitmaker/hitmaker.service';

@Component({
  selector: 'app-casting-update',
  templateUrl: './casting-update.component.html',
  styleUrls: ['./casting-update.component.css']
})
export class CastingUpdateComponent implements OnInit {

  movieId: number;
  title: string = '';
  description: string = '';
  mainImage: string = '';
  announcements: any;
  videos: any;
  bottomSection: string = 'video';
  admin: any;
  stageName = 'casting';
  playVideo: boolean = false;
  video: any;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private hitmakerService: HitmakerService,
    public auth: AuthenticationService,
    public sanitizer: DomSanitizer,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.movieId = this.activatedRoute.snapshot.params['id'];

    this.spinner.show();
    this.auth.checkUserAuthenticated().subscribe({
      next: (data: any) => {
        this.admin = data.adminRole;
        this.hitmakerStageDetails();
      },
      error: (err) => {
        console.error('Error checking user authentication:', err);
        this.spinner.hide();
      }
    });
  }
  hitmakerStageDetails() {
    this.hitmakerService.getHitmakerCastingPageDetails(this.movieId, 'CASTING').subscribe({
      next: (res: any) => {
        this.title = res?.title || '';
        this.description = res?.description || '';
        this.mainImage = res?.mainImage || '';
        this.announcements = res?.announcements || [];
        this.videos = res?.stageContent?.[0]?.stageContentDTOs || [];
        this.padVideoCards();
        this.spinner.hide();
      },
      error: (err) => {
        console.error('Error fetching hitmaker stage details:', err);
        alert('Movie or movie data does not exist!');
        window.location.href = '/hitmaker'
        this.spinner.hide();
      }
    });
  }

  bottomSectionChange(change: string) {
    this.bottomSection = change;
  }
  padVideoCards() {
  if (!this.videos) {
    this.videos = [];
  }

  // For non-admin users, filter out hidden content
  if (!this.admin) {
    this.videos = this.videos.filter(item => item.hidden === false);
  }

  const defaultImages = [
    '../../../../../../assets/images/hitmaker/videoCard2.png',
    '../../../../../../assets/images/hitmaker/videoCard3.png',
    '../../../../../../assets/images/hitmaker/videoCard4.png'
  ];

  if (this.videos.length === 0) {
    // No valid videos: add 3 placeholders
    for (let i = 0; i < 3; i++) {
      this.videos.push({
        thumbnailURL: defaultImages[i],
        stageContentLabel: 'Coming Soon',
        isPlaceholder: true
      });
    }
    return;
  }

  // If videos exist but are fewer than 4, pad to 4
  const placeholdersNeeded = 4 - this.videos.length;

  for (let i = 0; i < placeholdersNeeded; i++) {
    this.videos.push({
      thumbnailURL: defaultImages[defaultImages.length - placeholdersNeeded + i],
      stageContentLabel: 'Coming Soon',
      isPlaceholder: true
    });
  }
}


  deleteStageMovie(stageId: any) {
    if (confirm('Permanently delete the content?')) {
      this.hitmakerService.deleteStageContent(stageId).subscribe(() => {
        this.hitmakerStageDetails();
      });
    } else {
    }
  }

  hideStageContent(details: any) {
    console.log('details', details);
    if (
      confirm(
        'Toggle the public visibility of the content? (Note - Hidden content will only be visible to the producers of this movie or Creatics admins)'
      )
    ) {
      this.hitmakerService.hideStageContent(details, true).subscribe(() => {
        this.hitmakerStageDetails();
      });
    } 
  }

  showStageContent(stageId: any) {
    if (
      confirm(
        'Toggle the public visibility of the content? (Note - Hidden content will only be visible to the producers of this movie or Creatics admins)'
      )
    ) {
      this.hitmakerService.hideStageContent(stageId, false).subscribe(() => {
        this.hitmakerStageDetails();
      });
    } else {
    }
  }

  updateShowContent(details: any) {
    this.router.navigate(['/hitmaker/' + this.movieId + '/stage/' + this.stageName + '/update/' + details,]);
  }

  upvoteContent(details: any) {
    this.hitmakerService
      .getUserUpvoteBalnce()
      .subscribe((balanceResponse: any) => {
        const userBalance = balanceResponse - 1;

        if (userBalance >= 0) {
          this.hitmakerService.upvoteStageContent(details.id).subscribe(
            (response) => {
              if (response) {
                alert(
                  `Congratulations, you got 5 currency points! Your free Jewel balance for today is ${userBalance}`
                );
                this.hitmakerStageDetails();
              }
            },
            (error) => {
              alert('Episode already jeweled!');
            }
          );
        } else {
          alert('You have already used up your 10 free jewels for today.');
        }
      });
  }

  playVideo1(details: any) {
    this.playVideo = true;
    this.video = this.sanitizer.bypassSecurityTrustResourceUrl(details);
  }

  closeVideo() {
    this.video = '';
    this.playVideo = false;
  }
  uploadDetails() {
    this.router.navigate([
      '/hitmaker/' + this.movieId + '/stage/' + this.stageName + '/upload',
    ]);
  }
  toMoviePage(){
    window.location.href = '/hitmaker/' + this.movieId;
  }

}
